import styled from "styled-components";
import {DefaultTextBold} from "components/text/Text";

export const PaymentDetailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`

export const PaymentDetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const PaymentDetailText = styled.p`
  color: rgba(46, 58, 89, 0.7);

  @media (max-width: 700px){
    font-size: 12px;
  }

  @media (max-width: 500px){
    font-size: 10px;
  }
`

export const PaymentDetailItem = styled(DefaultTextBold)`
  font-size: 2vh;
  color: #2E3A59;
  text-align: right;

  @media (max-width: 700px){
    font-size: 14px;
  }

  @media (max-width: 500px){
    font-size: 10px;
  }
`

export const PaymentDetailSubtitle = styled.p`
  color: #696969;
  font-size: 1.5vh;
  text-align: right;
  
  @media (max-width: 700px){
    font-size: 10px;
  }

  @media (max-width: 500px){
    font-size: 8px;
  }
`
